<span>
  @if (this.idStatusQueue == statusQueueEnumChamando) {
    <div class="bullet" [style.background-color]="'#4287f5'"></div>
  }
  @if (this.idStatusQueue == statusQueueEnumEm_atendimento) {
    <div class="bullet" [style.background-color]="'#85C443'"></div>
  }
  @if (this.idStatusQueue != statusQueueEnumEm_atendimento && this.idStatusQueue != statusQueueEnumChamando) {
    <div class="bullet" [style.background-color]="'#c2c2c2'"></div>
  }
  {{statusQueueName}}
</span>
